module.exports = __webpack_public_path__ + "img/downarrow.f586a8c7.svg";